import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

export const EmpRoutes = () => {
  const User = useSelector(state => state.User)
  let isEmployer = User.category == 'EMPLOYMENT' || "GENERAL"
  return (
    isEmployer ? <Outlet /> : <Navigate to='/Error/' />
  )
}